import App from './app/App'
import 'core-js/stable'
import React from 'react'
import { createRoot } from 'react-dom/client'
import 'regenerator-runtime/runtime'
import { BrowserRouter } from 'react-router-dom'

import './styles/App.scss'

const container = document.getElementById('root')
if (!container) throw new Error('Failed to find the root element')
const root = createRoot(container)

// Determine basename based on environment variables (same logic as AccountStore)
const getBasename = () => {
  const isWhitelabel = import.meta.env.REACT_APP_IS_LABCHECK === 'true' || import.meta.env.REACT_APP_IS_LUBEWATCH === 'true'
  return !isWhitelabel ? '/cms' : '/'
}

root.render(
  <BrowserRouter basename={getBasename()}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </BrowserRouter>
)
